import { render } from "./SignupForm.vue?vue&type=template&id=787f5606&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=787f5606&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-787f5606"

export default script